import { Providers } from './integration.types';

export function resolveProviderAccountID(provider: Providers, accountID: string): string {
  return `${provider}:${accountID}`;
}
